import { useEffect, useState } from "react";
import { Typography, Card, CardContent, Grid, Badge, Button, useTheme, Box, Divider, IconButton, Toolbar, Tooltip, } from "@mui/material";

import FormatOverlineOutlinedIcon from '@mui/icons-material/FormatOverlineOutlined';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import StorefrontIcon from '@mui/icons-material/Storefront';
import CategoryIcon from '@mui/icons-material/Category';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import SendIcon from '@mui/icons-material/Send';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

import { useTranslation } from "react-i18next";
import useRequestIndentList from "../../hooks/useRequestIndentList";
import { tokens } from "../../theme/theme";
import { ErrorOutline, QrCodeScanner, ReportProblemOutlined, SettingsSuggest, WarningAmberOutlined } from "@mui/icons-material";
import MaterialStockDrawer from "./ledger/MaterialStockDrawer";
import { callApi } from "../../utils/apiClient";
import { API_ENDPOINTS } from "../../config/api/apiCall";
import { toast } from "react-toastify";
import AddNewRequestIndent from "../purchase/request-indent/AddRequestIndent";
import useUserPermissions from "../../components/user-permission/UserPermission";
import { hasPermission } from "../../components/user-permission/AuthorizationParameter";
import DashboardCard from "../../components/common/DashboardCard";


const StoreManagementMenu = ({ SetActive, handleBackDashboard }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();
    const [materialStockData, setMaterialStockData] = useState([]);
    const notifyCreatedIndent = useRequestIndentList('approved indent');
    const [requestIndentNotification, setRequestIndentNotification] = useState(0);
    const [open, setOpen] = useState(false);
    const [isProductsLoaded, setIsProductLoaded] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [newRequestIndent, setNewRequestIndent] = useState(false);
    const [menu, setMenu] = useState(true);
    const userPermissions = useUserPermissions();
    const [reorderlevelcount, setReorderLevelCount] = useState(0);

    const callback = () => {
        handleBackDashboard();
    };

    useEffect(() => {
        const list = notifyCreatedIndent.requestIndentList;
        if (Array.isArray(list) && list.length) {
            setRequestIndentNotification(list.length);
        }
    }, [notifyCreatedIndent.requestIndentList]);

    const ViewMaterialMinReorderLevel = () => {
        setOpen(!open);
    }

    useEffect(() => {
        if (!isProductsLoaded) {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
            };
            callApi(API_ENDPOINTS.MATERIAL_GET_STOCK_REORDERLEVEL, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setMaterialStockData(data);
                        setIsProductLoaded(true);
                        // setReorderLevelCount(data.length);
                    }
                })
                .catch(error => {
                    alert('error', error.message, 'Error');
                });
        }
    }, [isProductsLoaded]);

    const handleRaiseIndent = () => {
        if (selectedItems.length === 0) {
            toast.warning("Select at least one item to raise indent");
            return;
        }
        // You can replace this with your actual raise indent logic
        console.log("Raising indent for:", selectedItems);
        toast.success(`${selectedItems.length} item(s) added to indent!`);
        setNewRequestIndent(true);
        setOpen(false);
        setMenu(false);

    };

    const callbackNew = () => {
        setNewRequestIndent(false);
        setOpen(true);
        setMenu(true);

    };

    // const DashboardCard = ({ title, icon, onClick, badge, subtitle }) => (
    //     <Card
    //         elevation={3}
    //         sx={{
    //             backgroundColor: colors.primary[400],
    //             borderRadius: 3,
    //             p: 3,
    //             textAlign: "center",
    //             transition: "0.3s",
    //             "&:hover": {
    //                 transform: "translateY(-5px)",
    //                 boxShadow: theme.shadows[6],
    //             },
    //         }}
    //     >
    //         <Box
    //             sx={{
    //                 width: 60,
    //                 height: 60,
    //                 mx: "auto",
    //                 display: "flex",
    //                 alignItems: "center",
    //                 justifyContent: "center",
    //                 backgroundColor: colors.primary[400],
    //                 borderRadius: "50%",
    //                 mb: 2,
    //             }}
    //         >
    //             {badge ? (
    //                 <Badge
    //                     badgeContent={badge}
    //                     color="error"
    //                     overlap="circular"
    //                     sx={{
    //                         "& .MuiBadge-badge": {
    //                             fontSize: "10px",
    //                             height: "16px",
    //                             minWidth: "16px",
    //                             padding: "0 4px",
    //                         },
    //                     }}
    //                 >
    //                     {icon}
    //                 </Badge>
    //             ) : (
    //                 icon
    //             )}
    //         </Box>

    //         <Typography variant="h6" fontWeight={600}>
    //             {title}
    //         </Typography>

    //         <Button
    //             variant="contained"
    //             color="secondary"
    //             sx={{ mt: 2 }}
    //             onClick={onClick}
    //         >
    //             {subtitle}
    //         </Button>
    //     </Card>
    // );

    return (
        <>
            {menu && (

                <Box >
                    <Card sx={{ backgroundColor: "transparent", borderRadius: "0px", height: "48px" }}>
                        <CardContent>
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Typography variant="h5" color={colors.grey[100]} fontWeight="bold" justifyContent="center">{t('prod_menu.storemanagement')} </Typography>
                            </Box>

                        </CardContent>
                    </Card>

                    {/* scan bar code */}
                    {/* <Divider /> */}
                    <Box mt={.5} display="flex" justifyContent="space-between" alignItems="center">
                        <Box display="flex" justifyContent="space-between" alignItems="center">

                        </Box>

                        <Box display="flex"
                            mr={1}
                            gridColumn={{
                                xs: 'span 2',
                                sm: 'span 3',
                                md: 'span 3',
                                lg: 'span 2',
                                xl: 'span 2',
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderStyle: 'dashed', // Set border style to dashed
                                    }
                                }
                            }}
                        >

                            <IconButton aria-label="stock-upload" onClick={() => ViewMaterialMinReorderLevel()} style={{ borderRadius: '8px', marginRight: '10px' }}>

                                <Box display="flex" alignItems="center" gap={1}>
                                    <Typography
                                        textTransform="none"
                                        variant="button"
                                        style={{ marginLeft: '10px' }}
                                    >
                                      {t('inventory.material_stock_re_order_level')}
                                    </Typography>



                                    <Badge
                                        badgeContent={reorderlevelcount}
                                        color="error"
                                        overlap="circular"
                                        sx={{
                                            "& .MuiBadge-badge": {
                                                fontSize: "10px",
                                                height: "16px",
                                                minWidth: "16px",
                                                padding: "0 4px",
                                            },
                                        }}
                                    >
                                        <Tooltip title="Total materials with less than 50% of the reorder level">
                                            <ErrorOutline fontSize="small" color="error" />
                                        </Tooltip>
                                    </Badge>

                                    <Badge
                                        badgeContent={reorderlevelcount}
                                        color="warning"
                                        overlap="circular"
                                        sx={{
                                            "& .MuiBadge-badge": {
                                                fontSize: "10px",
                                                height: "16px",
                                                minWidth: "16px",
                                                padding: "0 4px",
                                            },
                                        }}
                                    >


                                        <Tooltip title="Total materials with greater than or equal to 50% and less than 75% of the reorder level">
                                            <WarningAmberOutlined fontSize="small" color="warning" />
                                        </Tooltip>
                                    </Badge>
                                </Box>


                            </IconButton>
                        </Box>
                    </Box>
                    <Divider />

                    {/* scan bar code */}
                    {/* <Divider /> */}

                    <Box p={2}>
                        <Grid container spacing={2} justifyContent="start" marginTop="10px"  >


                            {hasPermission(userPermissions, "Store Master", "Enabled") && (
                                <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>                                 
                                    <DashboardCard
                                        title={t('inventory.godown_master')}
                                        icon={<InventoryOutlinedIcon fontSize="large" color="secondary" />}
                                        onClick={() => SetActive("ViewStore")}
                                        subtitle="View"
                                    />
                                </Grid>)}

                            {hasPermission(userPermissions, "Store Ledger", "Enabled") && (
                                <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                                    <DashboardCard
                                        title={t('inventory.store_ledger')}
                                        icon={<StorefrontIcon fontSize="large" color="secondary" />}
                                        onClick={() => SetActive("StoreLedger")}
                                        subtitle="Add"
                                    />
                                </Grid>)}

                            {hasPermission(userPermissions, "Material Master", "Enabled") && (
                                <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                                    <DashboardCard
                                        title={t('inventory.material_master')}
                                        icon={<CategoryIcon fontSize="large" color="secondary" />}
                                        onClick={() => SetActive("ViewMaterial")}
                                        subtitle="Add"
                                    />
                                </Grid>)}


                            {hasPermission(userPermissions, "Material Stock", "Enabled") && (
                                <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>                                    
                                     <DashboardCard
                                        title={t('inventory.material_stock')}
                                        icon={<ShowChartIcon fontSize="large" color="secondary" />}
                                        onClick={() => SetActive("ViewMaterialStock")}
                                        subtitle="View"
                                    />
                                </Grid>)}

                            {hasPermission(userPermissions, "Approve Request Indent", "Enabled") && (
                                <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>                                 
                                     <DashboardCard
                                        title={t('inventory.approved_indent')}
                                        icon={<FactCheckIcon fontSize="large" color="secondary" />}
                                        onClick={() => SetActive("ApproveRequestIndent")}
                                        badge={requestIndentNotification}
                                        subtitle="Add"
                                    />
                                </Grid>
                            )}

                            {hasPermission(userPermissions, "Issue Indent", "Enabled") && (
                                <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                                     <DashboardCard
                                        title={t('inventory.material_requestation_note')}
                                        icon={<SendIcon fontSize="large" color="secondary" />}
                                        onClick={() => SetActive("IssueIndent")}                                        
                                        subtitle="Add"
                                    />
                                </Grid>
                            )}


                            {hasPermission(userPermissions, "Purchase Indent", "Enabled") && (
                                <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>                                   
                                      <DashboardCard
                                        title={t('inventory.purchase_indent')}
                                        icon={<ShoppingCartIcon fontSize="large" color="secondary" />}
                                        onClick={() => SetActive("PurchaseIndent")}                                        
                                        subtitle="Add"
                                    />
                                </Grid>)}

                            {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                                <FormatOverlineOutlinedIcon fontSize="large" />
                                <Typography variant="h6" mt={2}>Add Request Indent</Typography>
                                <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("AddRequestIndent")}>Add</Button>
                            </Card>
                        </Grid> */}
                        </Grid>
                    </Box>

                    <MaterialStockDrawer open={open} setOpen={setOpen} SetActive={SetActive} materialStockData={materialStockData} selectedItems={selectedItems} setSelectedItems={setSelectedItems} handleRaiseIndent={handleRaiseIndent} />


                </Box>)}

            {newRequestIndent && (
                <>
                    <AddNewRequestIndent handlecallback={callbackNew} editRequestIndentID={0} setEditRequestIndentID={0} selectedMode={0} setSelectedMode={0} formMode={0} materialData={selectedItems} />
                </>
            )}

        </>

    )
}
export default StoreManagementMenu;